import React, { useEffect } from "react";
import Form, { Group } from "~/common/components/Form";
import MultiCheckboxSelect from "~/common/components/MultiCheckboxSelect";
import {useGlobalStore} from "~/store";

const MultiSelectType = ({ useForm, form, apply, companyInfoData, setCompanyInfoValue }) => {
	const [
		{
			vc: { fields },
		},
	] = useGlobalStore();


	useEffect(() => {
		useForm.setValue(form.order.toString(), form.answer);
	}, []);

	function setOptions(options) {
		let newOptions = [];
		if(form.content === "fields") {
			fields.forEach((option) => {
				newOptions.push({ label: option.idx, value: option.field });
			})
		} else {
			options.forEach((option) => {
				newOptions.push({ label: option, value: option });
			});
		}
		return newOptions;
	}




	const selectedValues = useForm.watch(form.order.toString());

	// 기업정보 있을시 setValue
	useEffect(() => {
		companyInfoData && setCompanyInfoValue(form, useForm, form.content)
	}, [companyInfoData])



	return (
		<>
			<Form useForm={useForm} className="radio-form-wrap horiz multi-select-form-wrap">
				<Group label={form.title} required={form.required}>
					<MultiCheckboxSelect
						valueKey={"value"}
						name={form.order.toString()}
						options={setOptions(form.selectOption)}
						selectionLimit={5}
						placeholder={"선택해주세요"}
						selectedValues={selectedValues}
						disable={apply}
						required={form.content === "fields"}
					/>
				</Group>
			</Form>
		</>
	);
};

export default MultiSelectType;
